import { Component, OnInit, inject } from "@angular/core";
import { LgTranslateService, useTranslationNamespace } from "@logex/framework/lg-localization";
import { BaseComponent } from "@mrdm-self-service-frontend/shared/bases";
import {
    Auth0AuthorizationService,
    Auth0User
} from "@mrdm-self-service-frontend/shared/util-authorization";
import { SharedConfigService } from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import { takeUntil } from "rxjs/operators";
import { OrganizationPermissionService } from "../../authorization";

@Component({
    selector: "mrdm-self-service-frontend-access-denied",
    templateUrl: "./access-denied.component.html",
    styleUrls: ["./access-denied.component.scss"],
    providers: [useTranslationNamespace("APP._AccessDenied")],
    standalone: false
})
export class AccessDeniedComponent extends BaseComponent implements OnInit {
    private _organizationPermissionService = inject(OrganizationPermissionService);
    private _lgTranslate = inject(LgTranslateService);
    private _auth0AuthorizationService = inject(Auth0AuthorizationService);
    private _configService = inject(SharedConfigService);

    _user: Auth0User | undefined;
    _noOrgs = false;
    _links = this._configService.links;

    ngOnInit(): void {
        this._organizationPermissionService.allowedOrganizations$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(orgs => {
                if (orgs) {
                    this._noOrgs = orgs.length === 0;
                } else {
                    console.log("Couldn't get the Organizations!");
                }
            });

        this._user = this._auth0AuthorizationService.currentUserProfile;
    }

    _logout(): void {
        this._auth0AuthorizationService.logout();
    }
}
